import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c4b1e26e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c4b1e26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b1e26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b1e26e')) {
      api.createRecord('c4b1e26e', component.options)
    } else {
      api.reload('c4b1e26e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c4b1e26e&scoped=true&", function () {
      api.rerender('c4b1e26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VFRBCmrj5CmZ/JS/comp/DocBox.vue"
export default component.exports